<template>
  <div class="item-cart-container">
    <span class="amount mt16">${{item.egift_amount}} Gift Card</span>
    <div v-if="item.voucher_amount != null" class="row-item mt17">
      <img src="@/assets/pricetag.png" class="logo-price-tag" />
      <span class="gift-description ml10">
        Bonus
        <span class="amount gift-description">${{item.voucher_amount}}</span> service voucher
      </span>
    </div>
    <span
      class="btn-remove normal-button"
      v-bind:class="{noservice: item.voucher_amount == null}"
      @click="$emit('onRemove')"
    >Remove</span>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "ItemCart",
  components: {},
  props: {
    item: {
      type: Object,
      isRequired: true
    }
  },
  methods: {
    remove: index => {
      store.dispatch("cart/removeFromCart", index);
    }
  }
};
</script>
<style lang="scss" scoped>
.item-cart-container {
  display: flex;
  flex-direction: column;
  margin: 15px 10px 0 10px;
  padding-left: 20px;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  min-height: 103px;
  justify-content: center;
  .row-item {
    display: flex;
    align-items: center;
    .logo-price-tag {
      width: 25px;
      height: auto;
    }
  }
  .gift-description {
    font-size: 16px;
  }
  .btn-remove {
    font-family: "SFProText-Bold", -apple-system;
    font-weight: bold;
    font-size: 14px;
    color: #4a90e2;
    align-self: flex-end;
    position: relative;
    right: 10px;
  }
  .noservice {
    bottom: -16px;
  }
}
</style>